export default "<app-dynamic-content-offers [offerType]=\"SPECIAL_OFFERS\"></app-dynamic-content-offers>";